import Apis from 'apis';
import { objToQueryString } from 'utils/helpers';

export const api = Apis({});

export interface QueryProps {
  limit?: number | string;
  offset?: number | string;
  search?: string;
  advisor_type?: string;
  status?: string;
  impact?: string;
  environment_type?: string;
}

export default {
  getAllAdvisors: (query: QueryProps) =>
    `/scaling-advisor/advisor/?${objToQueryString(query)}`,
  getAdvisor: (uuid: string) => `/scaling-advisor/advisor/${uuid}/`,
  applyAdvisor: (uuid: string) => `/scaling-advisor/advisor/${uuid}/apply/`,
  ignoreAdvisor: (uuid: string) => `/scaling-advisor/advisor/${uuid}/ignore/`,
  revertAdvisor: (uuid: string) => `/scaling-advisor/advisor/${uuid}/revert/`,
  getDashboard: (query: QueryProps) =>
    `/scaling-advisor/dashboard/?${objToQueryString(query)}`,
};
